import { UNUSUAL_CONVERSION_ACTION } from "./constants";

const UnusualConversion = ({ id, auto = true }: { id: UNUSUAL_CONVERSION_ACTION; auto?: boolean }) => {
    return <div unusual-conversion-id={id} unusual-convert-on-load={auto ? "true" : "false"} />;
};

export default UnusualConversion;
